module.exports = __webpack_public_path__ + "static/img/s-back.16af31c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s-back.png
// module id = v5f6
// module chunks = 1